import { getLabel } from '../labels/labelling-service';
import logger from '../services/logging/logging-service';

import { forEach } from './array-utils';
import { isDOMElement, observeNodeMutation } from './dom-utils';

const ADV_INSERTED_STATE = 'inserted';
const ADV_REMOVED_STATE = 'removed';

/**
 * @param {HTML Node} advNode
 * @returns {Object}
 */
export const getAdvData = ($advNode) => ({
  reviveId:
    $advNode?.getAttribute('reviveid') ||
    $advNode?.getAttribute('data-reviveid') ||
    $advNode?.getAttribute('data-revive-id'),
  zoneId:
    $advNode?.getAttribute('zoneid') ||
    $advNode?.getAttribute('data-revivezoneid') ||
    $advNode?.getAttribute('data-revive-zoneid'),
});

/**
 *
 * @param {String} reviveId
 * @param {String} zoneId
 * @returns {HTML Node}
 */
export const createInsDataNode = (reviveId, zoneId) => {
  const $insDataNode = document.createElement('ins');
  $insDataNode.setAttribute('data-revive-zoneid', zoneId);
  $insDataNode.setAttribute('data-revive-id', reviveId);
  $insDataNode.setAttribute('style', 'display: none');
  return $insDataNode;
};

export const initInjectedAdv = (reviveId) => {
  // NOTE: Comparation with 'undefined' should be always === and not !==
  if (!(typeof window.reviveAsync === 'undefined')) {
    window.reviveAsync[reviveId].apply(window.reviveAsync[reviveId].detect());
  } else {
    logger.info('[ADV - INIT] window.reviveAsync is undefined');
  }
};

export const shouldInjectAdv = ($advDataNode) => $advDataNode.dataset.state !== ADV_INSERTED_STATE;
export const shouldRemoveAdv = ($advDataNode) => $advDataNode.dataset.state !== ADV_REMOVED_STATE;
export const setAdvInsertedState = ($advDataNode) => {
  $advDataNode.dataset.state = ADV_INSERTED_STATE;
};
export const setAdvRemovedState = ($advDataNode) => {
  $advDataNode.dataset.state = ADV_REMOVED_STATE;
};

const injectAdvLabel = ($advNode) => {
  const $labelNode = document.createElement('div');
  $labelNode.className = 'c-label--advertisement';
  const $labelText = document.createTextNode(getLabel('global.advertisement'));
  $labelNode.appendChild($labelText);
  // Append label as first child
  $advNode.insertBefore($labelNode, $advNode.firstChild);
  $advNode.dataset.labelled = 'true';
};

const shouldInjectLabel = ($advNode) => {
  if (!isDOMElement($advNode)) {
    logger.error('[ADV] $advNode is not a DOM element');
    return;
  }
  const height = parseInt(window.getComputedStyle($advNode).height, 10);
  const isLabelled = $advNode.dataset.labelled === 'true';
  return !isLabelled && height > 150;
};

const getAdvLabelObserverCallback = ($advNode) => (_mutationsList, mutationObserver) => {
  // Add a delay to improve the height calculation realiability
  setTimeout(() => {
    if (shouldInjectLabel($advNode)) {
      mutationObserver.disconnect();
      injectAdvLabel($advNode);
    }
  }, 300);
};

/**
 * Manipulate Banner is an API injected byy SkyMedia
 * @param {*} zoneId
 * @param {*} action --> 'refresh' | 'destroy'
 * @param {*} fullscreen --> true | false
 */
export const manipulateBanner = ({ zoneId, action, fullscreen }) => {
  // Workaround to fix bug on skymedia side
  setTimeout(
    () => {
      window.manipulateBanner?.(zoneId, action, fullscreen);
    },
    fullscreen ? 1000 : 0
  );
};

/**
 * Observe the adv containers and add labels right after the adv injection
 */
export const initAdvLabels = () => {
  const $advNodes = document.querySelectorAll('.c-adv');

  forEach(($advNode) => {
    if ($advNode.dataset.observed !== 'true') {
      $advNode.dataset.observed = 'true';
      const mutationsConfig = { attributes: false, childList: true, subtree: true };
      observeNodeMutation({ $targetNode: $advNode, callback: getAdvLabelObserverCallback($advNode), mutationsConfig });
    }
  })($advNodes);

  // After 10 sec check again the possible adv's not labelled (i.es. when you open a page in a new tab the observer does not work)
  setTimeout(() => {
    const $advNodesNotLabelled = document.querySelectorAll('.c-adv:not([data-labelled="true"])');
    forEach(($advNode) => {
      if (shouldInjectLabel($advNode)) {
        injectAdvLabel($advNode);
      }
    })($advNodesNotLabelled);
  }, 10000);
};
